// src/pages/MyInventoryPage.jsx
import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MyInventory from "../components/MyInventory";

const MyInventoryPage = () => {
  return (
    <>
      <Header />
      <MyInventory />
      <Footer />
    </>
  );
};

export default MyInventoryPage;
